let footerSwipers = {
    infobox3: {
        slider: false,
        elem: $('.js-slider-infobox-3'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
            simulateTouch: false,
            speed: 400,
            watchOverflow: true,
            roundLengths: true,
            pagination: {
                el: '.js-slider-infobox-3-pagination',
                clickable: true
            },
            on: {
                init: function () {
                    footerSwipers.infobox3.active = true;
                },
                slideChange: function() {
                    setTimeout(function() {
                        bLazy.revalidate()
                    }, 300);
                }
            }
        }
    },
};

rEvent.on('Window.resized', function() {
    checkSliders(footerSwipers);
});

const languagesFooter = {
    name: 'languagesFooter',
    trigger: $('.js-trigger-languages-footer'),
    elem: $('.js-target-languages-footer'),
    active: false,
    disabled: false,
    allowScroll: true,
    callback: {
        show: function() {
            $('.js-languages-footer').addClass('is-active');

            bLazy.revalidate();
        },
        hide: function() {
            $('.js-languages-footer').removeClass('is-active');
        }
    }
};

$(function() {
    checkSliders(footerSwipers);

    $('body').on('click', function (event) {
        if (activeElement && activeElement.active) {
            if (!$(event.target).closest(activeElement.elem).length && !$(event.target).closest(activeElement.trigger).length) {
                hideElem(activeElement);
            }
        }
    });

    for (const object of [languagesFooter]) {
        object.trigger.on('click', function(event) {
            if (!object.disabled || (object.disabled && !checkResolution(object.disabled))) {
                event.preventDefault();

                toggleElem(object);
            }
            else {
                hideElem(object);
            }
        });
    }

    $('.js-target-languages-footer > a').on('click', function() {
        hideElem(languagesFooter);
    });

    $('.js-newsletter-email').on('keyup change', function () {
        const $consents = $('.js-newsletter-consents'),
            value = $(this).val();

        if (value != '' && $(this).valid()) {
            $consents.slideDown(250);
        } else {
            $consents.slideUp(250);
        }
    });

    $('.js-form-subscription').validate({
        errorPlacement: function (error, element) {
            if (element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {
            $(form).find('[type="submit"]')
                .prop('disabled', true)
                .addClass('is-loading');

            Form.ajaxPost(form, function (data) {
                var msg = data.msg.format;
                if (!msg) {
                    msg = data.msg;
                }

                if (!data.status) {
                    Eshop.alert(msg, { type: 'danger' });
                } else {
                    Eshop.alert(msg);
                    $('.js-newsletter-email').val('').trigger('change');
                }

                $(form).find('[type="submit"]')
                    .prop('disabled', false)
                    .removeClass('is-loading');
            }, 'json');

            return false;
        }
    });
});